import { useState } from "react";

import Header from "../components/Header";
import Hero from "../components/Hero";
import EmotionSelector from "../components/EmotionSelector";
import CollectionTiers from "../components/CollectionTiers";
import Categories from "../components/Categories";
import Products from "../components/Products";
import WhyUs from "../components/WhyUs";
import DeliveryRegions from "../components/DeliveryRegions";
import Testimonials from "../components/Testimonials";
import GiftNoteBanner from "../components/GiftNoteBanner";
import InstagramGallery from "../components/InstagramGallery";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import QuickViewDialog from "../components/QuickViewDialog";
import { useCart } from "../lib/CartContext";

export default function Home() {
  const { addToCart } = useCart();
  const [quickView, setQuickView] = useState(null);

  return (
    <div className="min-h-screen bg-white text-[#222222]" data-testid="home-page">
      <Header />
      <Hero />
      <EmotionSelector />
      <CollectionTiers />
      <Categories />
      <Products onAddToCart={addToCart} onQuickView={setQuickView} />
      <WhyUs />
      <DeliveryRegions />
      <Testimonials />
      <GiftNoteBanner />
      <InstagramGallery />
      <FAQ />
      <Footer />

      <FloatingButtons />

      <QuickViewDialog
        product={quickView}
        onClose={() => setQuickView(null)}
        onAddToCart={addToCart}
      />
    </div>
  );
}
